import {
  PIN_CODE_SEND,
  PIN_CODE_CONFIRM,
  UPDATE_PIN,
  CONFIRM_PHONE,
  REGISTER,
  DISABLE,
  UPDATE_PHONE,
} from '../../rest/consumer/consumer.request-urls';
import { TOKEN_URL, MOBILE_URL, MOBILE_CONFIRM_URL } from '../../rest/oauth/oauth.request-urls';

interface IHandledErrors {
  [key: string]: number[];
}

export const handledErrors: IHandledErrors = {
  [PIN_CODE_SEND]: [400],
  [PIN_CODE_CONFIRM]: [400],
  [UPDATE_PIN]: [400],
  [UPDATE_PHONE]: [400],
  [CONFIRM_PHONE]: [400],
  [REGISTER]: [400],
  [DISABLE]: [],
  [TOKEN_URL]: [401],
  [MOBILE_URL]: [400],
  [MOBILE_CONFIRM_URL]: [400],
};
